/**
 * Ctextfx scramble randomness — the single owner of the random glyph/delay
 * policy shared by the first-render seed in `Ctextfx.tsx` and the shared
 * scramble scheduler.
 */

const SCRAMBLE_DELAY_FLOOR_MS = 32;

interface RandomScrambleDelayInput {
  scrambleMaxMs: number;
  scrambleMinMs: number;
}

interface RandomScrambleGlyphInput {
  exclude: ReadonlySet<string>;
  glyphs: string;
}

const RANDOM_SCRAMBLE_GLYPH_ATTEMPTS = 12;

export function randomScrambleDelayMs({
  scrambleMaxMs,
  scrambleMinMs,
}: RandomScrambleDelayInput): number {
  const low = Math.max(SCRAMBLE_DELAY_FLOOR_MS, scrambleMinMs);
  const high = Math.max(low, scrambleMaxMs);
  return low + Math.random() * (high - low);
}

export function randomScrambleGlyph({
  exclude,
  glyphs,
}: RandomScrambleGlyphInput): string {
  const poolSize = glyphs.length;
  for (let attempt = 0; attempt < RANDOM_SCRAMBLE_GLYPH_ATTEMPTS; attempt++) {
    const glyph = glyphs[Math.floor(Math.random() * poolSize)];
    if (!exclude.has(glyph)) return glyph;
  }
  return glyphs[Math.floor(Math.random() * poolSize)];
}
